<template>
  <div class="sidebar-header">
    <logo class="logo"/>
  </div>
</template>

<script>
import Logo from '@/support/components/Logo.vue';

export default {
  name: 'SidebarHeader',

  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-header {
    display: flex;
    width: 100%;
    justify-content: center;
    border-bottom: 1px solid #e2e8f0;

    > .logo {
      height: 60px;
      width: 100px;
    }
  }
</style>
